<template>
  <div class="user-info-wrapper">
    <div class="form-wrapper">
      <UserForm ref="userForm" />
    </div>
    <div class="bottom" :style="{ marginBottom: btnPaddingBottom }">
      <p class="tips">注：头像可在南方Plus App的个人中心修改</p>
      <NfButton width="6.5rem" @click="handleReviseSaveUserInfo">{{ btnText }}</NfButton>
    </div>
  </div>
</template>

<script>
import UserForm from "./components/UserForm"
import NfButton from "@/components/NfButton"
import { mapActions, mapMutations, mapGetters } from "vuex"
import { FORM_ERR_AMP, USER_INFO_KEY_MAP } from "@/dictionary"

export default {
  name: "userInfo",
  data() {
    return {
      isFromMyWork: false
    }
  },
  methods: {
    ...mapMutations({
      setNextRouteName: "userInfo/setNextRouteName",
      showToast: "toast/showToast"
    }),
    ...mapActions({
      saveReviseUserInfo: "userInfo/saveReviseUserInfo",
      getGradeList: "activityInfo/getGradeList"
    }),
    handleCheckFromData(formData) {
      let hasInputAll = true
      const hasInputInfo = value => {
        let result = true
        const isObject = typeof value === "object"
        if (isObject) {
          const keys = Object.keys(value)
          result = keys.length > 0 && value[keys[0]] !== ""
        } else {
          result = value !== "" && value !== undefined
        }
        return result
      }
      for (let i = 0; i < this.defaultOptions.length; i++) {
        const key = this.defaultOptions[i]
        const userKey = USER_INFO_KEY_MAP[key]
        if (key !== "HEAD" && !hasInputInfo(formData[userKey])) {
          const errMsg = FORM_ERR_AMP[key]
          hasInputAll = false
          this.showToast(errMsg)
          break
        }
      }
      return hasInputAll
    },
    async handleReviseSaveUserInfo() {
      const userInfo = this.$refs.userForm.formData
      const formData = {}
      this.defaultOptions.forEach(optionsKey => {
        const key = USER_INFO_KEY_MAP[optionsKey]
        formData[key] = userInfo[key]
      })
      const formResult = this.handleCheckFromData(formData)
      if (formResult) {
        const params = {
          params: {
            defaultOpt: formData
          }
        }
        const result = await this.saveReviseUserInfo(params)
        if (result) {
          this.showToast("保存成功")
          this.handleJumpNextPage()
          this.setNextRouteName("")
        }
      }
    },
    handleJumpNextPage() {
      const nextRouteName = this.nextRouteName
      if (nextRouteName) {
        this.$router.replace({ name: nextRouteName })
      } else {
        this.$router.go(-1)
      }
    },
    _getGradeList() {
      const hasGrade = this.defaultOptions.includes("GRADE")
      if (hasGrade) {
        this.getGradeList()
      }
    }
  },
  components: {
    UserForm,
    NfButton
  },
  computed: {
    ...mapGetters({
      defaultOptions: "activityInfo/defaultOptions",
      nextRouteName: "userInfo/nextRouteName",
      systemInfo: "systemInfo",
      userInfo: "userInfo/userInfo"
    }),
    btnText() {
      return this.nextRouteName ? "保存信息，下一步" : "保存"
    },
    btnPaddingBottom() {
      return this.systemInfo.isPhoneX ? "34px" : ""
    }
  },
  beforeRouteEnter(to, from, next) {
    const isFromMyWork = from.name === "myWork"
    next(vm => {
      vm.isFromMyWork = isFromMyWork
    })
  },
  created() {
    this._getGradeList()
  }
}
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  .form-wrapper {
    flex: 1;
    overflow: auto;
    width: 100%;
  }
  .bottom {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.3rem 0 0.4rem;
    .tips {
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #999999;
      text-align: center;
      margin-bottom: 0.3rem;
    }
  }
}
</style>
